ACC.productSheetSawing = {

    SHEET_DATA_VALID: 0,
    SHEET_DATA_INVALID: 1,
    ERR_SHEET_LENGTH_RANGE: 20,
    ERR_SHEET_WIDTH_RANGE: 21,

    dimensionTableCustomVariant: $("#dimension-table .custom-variant"),
    dimensionTableCustomVariantLength: $("#dimension-table .link-pdp-customLength"),
    dimensionTableCustomVariantWidth: $("#dimension-table .link-pdp-customWidth"),

    openSheetSawingPopup: function (e, inputType) {

        var $this = $(e.target).closest(".custom-variant");

        if ($('.custom-dimension-sheet-wrapper').hasClass("sheet-variant")) {

            if (!$this.hasClass("not-active") &&
                ($this.attr('data-state') == "orderable" || $this.attr('data-state') == "disabled") &&
                !$this.hasClass('custom-variant-selection') &&
                !$('.custom-dimension-sheet-wrapper').find('.custom-dimension-sheet-input-popup').hasClass('open')
            ) {
                // show popup for normal sawing:
                $("#sawingType").val("SHEET");
                ACC.productSheetSawing.callSheetSawingColorBox(inputType);
            }

            if (!$this.hasClass("not-active") &&
                ($this.attr('data-state') == "selected") &&
                !$('.custom-dimension-sheet-wrapper').find('.custom-dimension-sheet-input-popup').hasClass('open')) {

                // deselect sheet sawing
                ACC.productSheetSawing.resetCustomSheetDimension(inputType, true);
                ACC.productSheetSawing.hideSheetSawingDataOnPDP();
                $(".qty_block .no-variant-wrapper").removeClass('no-pointer');

                if (typeof resetQuantity !== "undefined") {
                    resetQuantity();
                }
                callVariantResource(ACC.productDetail.getAllDimensionCodes());
            }
        }
    },

    setSheetSawing: function () {

        ACC.productSheetSawing.dimensionTableCustomVariantLength.on("click", function (e) {
            e.preventDefault();
            ACC.productSheetSawing.openSheetSawingPopup(e, "length");
        });
        ACC.productSheetSawing.dimensionTableCustomVariantWidth.on("click", function (e) {
            e.preventDefault();
            ACC.productSheetSawing.openSheetSawingPopup(e, "width");
        });

        // Cancel button in popup
        $('.custom-dimension-sheet-wrapper .custom-dimension-input-popup_cancel').on('click', function (e) {
            e.preventDefault();

            ACC.productSheetSawing.hideSheetSawingPopup();
            $.colorbox.close();
        });

        // ready button in popup
        $('#dimension-table .send-sheet-sawing-data').on("click", function (e) {
            e.preventDefault();
            ACC.productSheetSawing.submitSheetSawing();
        });

    },

    submitSheetSawing: function () {
        var isValid = ACC.productSheetSawing.validateSheetPopup();

        if (isValid) {
            // set sheet sawing data in add to cart form
            $("#sawingLengthTolerance").val($('.sheet-length-tolerance .custom-dimension-length-tolerance-select').val());
            $('#customLength').val($(".input-sheet-length").val());
            $("#sawingWidthTolerance").val($('.sheet-width-tolerance .custom-dimension-width-tolerance-select').val());
            $('#customWidth').val($(".input-sheet-width").val());


            $("#sawingType").val('SHEET');
            $("#sawingCode").val("");
            $("#sawingAngleA").val("");
            $("#sawingAngleB").val("");
            callVariantResource(ACC.productDetail.getAllDimensionCodes());
            if ($('#qtyInput').val() > 0) {
                quantityChange();
            }
        }
    },

    handleSheetPopupResponse: function (isSuccess) {
        var $customDimensionSheetInputPopup = $(".custom-dimension-sheet-input-popup");
        if (!$("#sawingType").val()) return;
        if (isSuccess) {
            // hide popup and prepare addToCart/quantity

            $(".custom-dimension-sheet-wrapper .custom-dimension-minmax-popup").addClass("hide");

            $('#qtyInput').prop("disabled", false);

            if ($('.input-sheet-length').val()) {
                unselectAll(ACC.productSheetSawing.getCustomDimensionVal('length'));
                $('.input-sheet-length').removeClass("dimension-input-border");
                ACC.productSheetSawing.dimensionTableCustomVariantLength.addClass("custom-variant-selection").attr('data-state', "selected");
                ACC.productSheetSawing.dimensionTableCustomVariantLength.find('.value').text($('.input-sheet-length').val());
            }
            if ($('.input-sheet-width').val()) {
                unselectAll(ACC.productSheetSawing.getCustomDimensionVal('width'));
                $('.input-sheet-width').removeClass("dimension-input-border");
                ACC.productSheetSawing.dimensionTableCustomVariantWidth.addClass("custom-variant-selection").attr('data-state', "selected");
                ACC.productSheetSawing.dimensionTableCustomVariantWidth.find('.value').text($('.input-sheet-width').val());
            }
            $('.reset-icon').removeClass("hide");
            $('.custom-dimension-sheet-wrapper').addClass("hide");
            $('.custom-dimension-sheet-input-popup').addClass("hide");
            $('.custom-dimension-sheet-wrapper').find('.custom-dimension-sheet-input-popup').removeClass('open');

            $('.show-sheet-custom-data').addClass('hide');

            $.colorbox.close();
        } else {
            $customDimensionSheetInputPopup.find(".help-inline").removeClass("hide");
            $customDimensionSheetInputPopup.find(".custom-dimension-response-error-popup").removeClass("hide");
            $('#customLength').val("");
            $('#customWidth').val("");
        }
    },

    getCustomDimensionVal: function (type) {
        var val;
        $(".dimension-count-for-custom-dimension").each(function () {
            if ($(this).prev().hasClass('link-pdp-custom' + type.substr(0, 1).toUpperCase() + type.substr(1))) {
                val = $(this).val();
                return false;
            }
        });

        return val;
    },

    resetCustomSheetDimension: function (inputType, resetAll) {
        // restore custom field data

        var resetLength = (inputType == 'length');
        var resetWidth = (inputType == 'width');

        if (resetLength || resetAll) {
            // reset input field
            $('.input-sheet-length').val("");

            ACC.productSheetSawing.dimensionTableCustomVariantLength.attr('data-state', "orderable");
            ACC.productSheetSawing.dimensionTableCustomVariantLength.removeClass("custom-variant-selection");
            ACC.productSheetSawing.dimensionTableCustomVariantLength.find('.value').text(ACC.productSheetSawing.dimensionTableCustomVariantLength.attr('data-placeholder'));

            $('#customLength').val("");
            $('#sawingLengthTolerance').val("");
        }
        if (resetWidth || resetAll) {
            // reset input field
            $('.input-sheet-width').val("");

            ACC.productSheetSawing.dimensionTableCustomVariantWidth.attr('data-state', "orderable");
            ACC.productSheetSawing.dimensionTableCustomVariantWidth.removeClass("custom-variant-selection");
            ACC.productSheetSawing.dimensionTableCustomVariantWidth.find('.value').text(ACC.productSheetSawing.dimensionTableCustomVariantWidth.attr('data-placeholder'));

            $('#customWidth').val("");
            $('#sawingWidthTolerance').val("");
        }

        if (resetAll) {
            // remove addToCart form fields
            $("#sawingType").val("");
            $("#sawingCode").val("");

            // hide sheet popup elements
            $('.reset-icon').addClass("hide");
            if ($('.sheet-tolerance').length) {
                $('.sheet-tolerance').removeClass('hide');
            } else {
                $('.sheet-tolerance').addClass('hide');
            }
            // addToCart handling
        }
    },

    showSheetPopup: function (inputType) {
        ACC.productSheetSawing.resetValidationMessages();

        $('.custom-dimension-sheet-wrapper').removeClass("hide");
        $('.custom-dimension-sheet-wrapper').find('.custom-dimension-sheet-input-popup').removeClass("hide");
        $('.custom-dimension-sheet-wrapper').find('.custom-dimension-sheet-input-popup').addClass('open');

        if (inputType == 'length') {
            $('.input-sheet-length').val("");
            $('.custom-dimension-sheet-wrapper').find('.custom-dimension-sheet-input-popup').find('.input-sheet-length').select();
        } else if (inputType == 'width') {
            $('.input-sheet-width').val("");
            $('.custom-dimension-sheet-wrapper').find('.custom-dimension-sheet-input-popup').find('.input-sheet-width').select();
        }
    },

    hideSheetSawingDataOnPDP: function () {
        $('.show-sheet-custom-data').addClass('hide');
    },

    hideSheetSawingPopup: function () {
        $('.custom-dimension-sheet-wrapper').addClass("hide");
        $('.custom-dimension-sheet-input-popup').removeClass('open');
        $('.custom-dimension-sheet-input-popup').addClass("hide");
    },

    // ============================== Section: Validation ==============================
    resetValidationMessages: function () {
        $('.custom-dimension-sheet-wrapper .help-inline').addClass('hide');
        $('.custom-dimension-sheet-wrapper .help-inline span').addClass('hide');
        $('.input-sheet-length').removeClass('dimension-input-border');
        $('.input-sheet-width').removeClass('dimension-input-border');
    },

    // used in validateSheetPopup
    validateSheetDimentions: function ($inputLength, $inputWidth) {


        var result = "";
        $.ajax({
            async: false,
            type: "POST",
            dataType: 'json',
            contentType: 'application/json',
            url: $('.send-sheet-sawing-data').data('url'),
            data: JSON.stringify({
                sawingLength: $inputLength.val(),
                sawingWidth: $inputWidth.val(),
                sawingType: "SHEET",
                selectionCodes: ACC.productDetail.getAllDimensionCodes(),
                selectionValues: ACC.productDetail.getSelectedVariantValues()
            }),
            success: function (data, status) {
                result = data.errorcode;
            }
        });

        return result;
    },

    validateSheetPopup: function () {
        var popupIsValid = true;
        var $inputSheetLength = $('.custom-dimension-sheet-wrapper .input-sheet-length');
        var $inputSheetWidth = $('.custom-dimension-sheet-wrapper .input-sheet-width');

        // remove all old validation errors
        $('.custom-dimension-sheet-wrapper .help-inline').addClass("hide");
        $('.custom-dimension-sheet-wrapper .help-inline span').addClass("hide");

        $inputSheetLength.removeClass("dimension-input-border");
        $inputSheetWidth.removeClass("dimension-input-border");

        // ---------- validate sheet length and width ------------------------------
        var result = ACC.productSheetSawing.validateSheetDimentions($inputSheetLength, $inputSheetWidth);

        if (result > 0) {
            popupIsValid = false;
        }
        switch (result) {
            case ACC.productSheetSawing.SHEET_DATA_INVALID :
                $('.sheet-custom-data .help-inline').removeClass("hide");
                $('.sheet-custom-data .help-inline .sheet-validation-invalid-error').removeClass("hide");
                break;
            case ACC.productSheetSawing.ERR_SHEET_LENGTH_RANGE :
                $('.sheet-custom-data .help-inline').removeClass("hide");
                $inputSheetLength.addClass("dimension-input-border");
                $('.sheet-custom-data .help-inline .sheet-validation-length-minmax-error').removeClass("hide");
                break;
            case ACC.productSheetSawing.ERR_SHEET_WIDTH_RANGE :
                $('.sheet-custom-data .help-inline').removeClass("hide");
                $inputSheetWidth.addClass("dimension-input-border");
                $('.sheet-custom-data .help-inline .sheet-validation-width-minmax-error').removeClass("hide");
                break;
            default:
                $('.sheet-custom-data .help-inline').addClass("hide");
                $('.sheet-custom-data .help-inline span').addClass("hide");
                $inputSheetLength.removeClass("dimension-input-border");
                $inputSheetWidth.removeClass("dimension-input-border");
                break;
        }

        if (popupIsValid) {
            $('#send-sheet-sawing-data').val(true);
        }

        return popupIsValid;
    },

    callSheetSawingColorBox: function (inputType) {
        $.colorbox({
            inline: true,
            href: ".custom-dimension-sheet-wrapper",
            transition: "none",
            scrolling: false,
            innerWidth: 550,
            onLoad: function () {
                $('#cboxClose').remove();
            },
            onComplete: function () {
                ACC.productSheetSawing.showSheetPopup(inputType);
                $.colorbox.resize();
            },
            onClosed: function () {
                ACC.productSheetSawing.hideSheetSawingPopup();
            }
        });
    }
}

$(document).ready(function () {

    if ($(".page-productDetails").length) {

        with (ACC.productSheetSawing) {
            setSheetSawing();
        }

        $('.custom-dimension-sheet-input-popup').on('keydown', function (e) {
            var $this = $(this);
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                if ($this.hasClass('open')) {
                    ACC.productSheetSawing.submitSheetSawing();
                    e.preventDefault();
                    return false;
                }
            }
        });

    }
})

